<template>
  <div v-if="visible" :class="`preloader preloader-${firstVisit ? 'first-visit' : ''} preloader-${loaded ? 'hide' : ''}`">
    <img class="preloader-progress" src="/static/preloader.gif"/>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'preloader',
  computed: mapGetters({
    firstVisit: 'firstVisit',
    loaded: 'loaded',
  }),
  watch: {
    loaded() {
      setTimeout(() => {
        this.visible = false;
      }, 2200);
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  mounted() {
    if (this.firstVisit && location.pathname.indexOf('dark') < 0) {
      this.$store.dispatch('firstVisitTimeout');
      this.$cookie.set('visited', 'true', 1111);
    }
  },
};
</script>

<style scoped>
@keyframes loaded{
  from{
    /*max-width: 100vw;*/
    opacity: 1;
  }
  50%{
    /*max-width: $mediaSmallScreen;*/
  }
  100%{
    /*max-width: $mediaSmallScreen;*/
    opacity: 0;
  }
}

@keyframes loadedFirstTime{
  from{
    /*max-width: 100vw;*/
    opacity: 1;
  }
  50%{
    /*max-width: $whitePanel;*/
  }
  100%{
    /*max-width: $whitePanel;*/
    opacity: 0;
  }
}

.preloader{
  background: white;
  position: fixed;
  z-index: 9999;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;

  &-progress{
    transition: opacity .3s ease-in-out;
    position: absolute;
    opacity: 1;
    left: 45%;
    top: 40%;
  }

  &-hide{
    animation: loaded 2s ease-in-out;
    /*max-width:  $mediaSmallScreen;*/
    /*width: $whitePageWide;*/
    width: 100%;
    opacity: 0;

    @media (max-width: $mediaIpad) {
      min-width: $whitePageWide;
    }

    &.preloader-first-visit{
      animation: loadedFirstTime 2s ease-in-out;
      /*max-width: $whitePageMaxWide;*/
      @media (max-width: $mediaIpad) {
        min-width: $whitePanel;
      }
    }


    .preloader-progress{
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue